import { Store } from 'libx'
import { observable, action } from 'mobx'
import memoize from 'lodash/memoize'
import storage from 'misc/localStorage'

const sounds = {
  gotMessage: {
    mp3: require('assets/sounds/got-message.mp3'),
    ogg: require('assets/sounds/got-message.ogg')
  },
  sendMessage: {
    mp3: require('assets/sounds/send-message.mp3'),
    ogg: require('assets/sounds/send-message.ogg')
  }
}

export default class SoundStore extends Store {
  @observable isEnabled = false

  constructor () {
    super(...arguments)
    this._getAudio = memoize(this._getAudio)
    this.setEnabled(storage.getItem('soundEnabled') !== 'disabled')
    // Initialize all audio objects
    Object.keys(sounds).forEach(key => this._getAudio(key))
  }

  @action setEnabled (enabled) {
    this.isEnabled = enabled
    storage.setItem('soundEnabled', enabled ? 'enabled' : 'disabled')
  }

  playSendMessage () {
    return this._play('sendMessage')
  }

  playGotMessage () {
    return this._play('gotMessage')
  }

  _play (id) {
    if (!this.isEnabled) {
      return
    }

    const audio = this._getAudio(id)
    audio.pause()
    // Prevents some stupid DOMException, only way to do it.
    // When in doubt, setTimeout
    setTimeout(() => {
      audio.currentTime = 0
      audio.play()
    }, 10)
  }

  _getAudio (id) {
    const audio = new Audio()
    const type = audio.canPlayType('audio/mpeg')
      ? 'mp3'
      : 'ogg'
    audio.volume = 0.6
    audio.type = type === 'mp3'
      ? 'audio/mpeg'
      : 'audio/ogg'
    audio.src = sounds[id][type]
    return audio
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/SoundStore.js